export default {
	headers: {
		financialFiles: 'Financial File',
		user: 'User',
		change: 'Change',
		changeType: 'Change Type',
		date: 'Date',
		description: 'Description'
	},
	label: {
		logType: 'Log Type',
		user: 'User',
		fromDate: 'From Date',
		toDate: 'To Date'
	},

	accounts: 'Accounts',
	accounting: 'Accounting',
	currencies: 'Currencies',
	'financial-file': 'Financial File',
	'fund-flow': 'Fund Flow',
	manufacturing: 'Manufacturing',
	'material-flow': 'Material Flow',
	'material-warehouse': 'Material Warehouse',
	users: 'Users',


	fetch: 'Fetch',
	create: 'Create',
	update: 'Update',
	edit: 'Edit',
	delete: 'Delete',
	post: 'Post',
	unPost: 'Un Post',

	search: 'Search',

	'full-log-types': {
		'financial-flies': 'Financial Files',
		accounts: 'Accounts',
		'contact-infos': 'Contact Infos',
		'financial-file-config': 'Financial File Configuration',
		currencies: 'Currencies',
		'custom-statements': 'Custom Statements',
		'receipt-bonds': 'Receipt Bonds',
		'payment-bonds': 'Payment Bonds',
		'cash-entries': 'Cash Entries',
		'accounting-entries': 'Accounting Entries',
		'cash-bonds': 'Cash Bonds',
		'accounting-bonds': 'Accounting Bonds',
		'receipt-entries': 'Receipt Entries',
		'payment-entries': 'Payment Entries',
		'sub-invoices': 'Sub Invoices',
		'buy-invoices': 'Buy Invoices',
		'sale-invoices': 'Sale Invoices',
		'buy-refund-invoices': 'Buy Refund Invoices',
		'sale-refund-invoices': 'Sale Refund Invoices',
		'buy-material-entries': 'Buy Material Entries',
		'sale-material-entries': 'Sale Material Entries',
		'buy-refund-material-entries': 'Buy Refund Material Entries',
		'sale-refund-material-entries': 'Sale Refund Material Entries',
		roles: 'Roles',
		users: 'Users',
		'transaction-bonds': 'Transaction Bonds',
		'transaction-entries': 'Transaction Entries',
		'manufacturing-files': 'Manufacturing Files',
		'manufacturing-file-entries': 'Manufacturing File Entries',
		'manufacturing-file-entry-raw-materials': 'Manufacturing File Entry Raw Materials',
		'material-journals': 'Material Journals',
		'material-entries': 'Material Entries',
		'receipt-invoice-transactions': 'Receipt Invoices Transactions',
		'payment-invoice-transaction': 'Payment Invoices Transaction',
		'expenses-buy-invoice-transaction': 'Expenses Buy Invoice Transaction',
		'expenses-sale-invoice-transaction': 'Expenses Sale Invoice Transaction',
		materials: 'Materials',
		'linked-materials': 'Linked Materials',
		'unit-sizes': 'Unit Sizes',
		warehouses: 'Warehouses',
		'delivery-statuses': 'Delivery Statuses',
		'invoice-transactions': 'Invoice Transactions'
	}
}